module.exports = __webpack_public_path__ + "static/media/Header3.7f1a2174.jpg";